import { Component, OnInit } from "@angular/core";

import {
  DialogRef,
  DialogParams,
  Dialog
} from "../../../../dialog/dialog.base";
import { FormData } from "../../../classes/data";
import { FormSchema } from "../../../classes/schema";

@Component({
  selector: "uex-color-picker-modal",
  templateUrl: "./color-picker.modal.html",
  host: {
    class: "uex-color-picker-modal"
  }
})
export class InputColorPickerModal implements OnInit {
  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams
  ) {
    this.dialog = this._dialogRef.dialog;
    this.dialog.setSize("xs");
  }

  public ready = false;

  public dialog: Dialog;
  public color: string = null;

  public form: FormData;
  public schema: FormSchema;

  public ngOnInit() {
    this.form = this._dialogParams.get("form");
    this.schema = this._dialogParams.get("schema");
    this.color = this.schema.value;
    setTimeout(() => {
      this.ready = true;
    }, 300);
  }

  public apply() {
    this.dialog.returnValue(this.color);
  }
}
